import React, { useEffect } from "react";
import { Cookies } from "react-cookie";
import { AUTH_TOKEN, REFRESH_TOKEN } from "utils/constants";
import { useStoreActions } from "easy-peasy";
import { isEmpty, jwt } from "utils/utils";
import { fetchQuery } from "utils/relay";
import { publicKeyQuery } from "routes/auth/fetchPublicKey";

function AuthWrapper({ children }: any) {
	const clearAuthToken = useStoreActions(
		(actions: any) => actions.auth.clearAuthToken
	);
	const clearRefreshToken = useStoreActions(
		(actions: any) => actions.auth.clearRefreshToken
	);
	const updateAuthToken = useStoreActions(
		(actions: any) => actions.auth.updateAuthToken
	);
	const updateRefreshToken = useStoreActions(
		(actions: any) => actions.auth.updateRefreshToken
	);
	const setPublicKey = useStoreActions(
		(actions: any) => actions.auth.setPublicKey
	);
	const listenCookieChange = (callback: any, interval = 1000) => {
		let lastCookie = document.cookie;
		return setInterval(() => {
			let cookie = document.cookie;
			if (cookie !== lastCookie) {
				try {
					callback({ oldValue: lastCookie, newValue: cookie });
				} finally {
					lastCookie = cookie;
				}
			}
		}, interval);
	};

	useEffect(() => {
		const listenerId = listenCookieChange(
			async ({ oldValue, newValue }: any) => {
				let newCookie = new Cookies(newValue);
				let localAuth = newCookie.get(AUTH_TOKEN);
				if (isEmpty(localAuth)) {
					return;
				}
				let localRefresh = newCookie.get(REFRESH_TOKEN);
				let publicKey: any = await fetchQuery(publicKeyQuery);
				setPublicKey(publicKey);
				jwt.verify(
					localAuth,
					publicKey?.jwtPublicKey,
					{ algorithms: ["RS256"] },
					(err: any, decoded: any) => {
						if (err) {
							console.log("clearing in authwrapper");
							console.log(localAuth, "authwrapper");
							console.log(publicKey, "authwrapper");
							clearAuthToken();
							clearRefreshToken();
						} else if (decoded) {
							let date = new Date(0);
							let tokenObj: any = {
								self: localAuth,
								expiry: date.setUTCSeconds(decoded.exp || 0),
							};
							updateAuthToken(tokenObj);
							updateRefreshToken({
								self: localRefresh,
								expiry: date.setUTCSeconds(decoded.exp || 0),
							});
						}
					}
				);
			},
			1000
		);
		return () => {
			clearInterval(listenerId);
		};
	}, []);
	return <div>{children}</div>;
}

export default AuthWrapper;
